export default __webpack_public_path__ + "static/ezpawn-hiring-ad-95c0bf7ab1f37c857d1cacdce0f81f80.jpg";